import { useState } from "react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full border-b border-[#D6C2A6] bg-transparent py-3 text-base text-[#2F3338] outline-none transition-colors duration-300 placeholder:text-[#2F3338]/40 focus:border-[#3F5A47]";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await fetch(`${API}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("send failed");
      toast.success("Tak for din besked – vi vender tilbage hurtigst muligt.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Beskeden kunne ikke sendes lige nu. Prøv igen om lidt.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="kontakt" data-testid="contact-section" className="scroll-mt-24 px-6 py-28 lg:py-40">
      <div className="mx-auto max-w-xl">
        <Reveal className="text-center">
          <h2 className="font-serif text-3xl text-[#3F5A47] sm:text-4xl lg:text-5xl">Kontakt os</h2>
          <div className="mx-auto mt-7 h-px w-16 bg-[#3F5A47]" />
          <p className="mt-8 text-base leading-relaxed text-[#2F3338]/80">
            Udfyld formularen, så vender vi tilbage hurtigst muligt.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <form onSubmit={onSubmit} className="mt-14 space-y-9">
            <div>
              <label htmlFor="kontakt-navn" className="text-xs font-medium tracking-[0.25em] text-[#B46A45]">
                NAVN
              </label>
              <input
                id="kontakt-navn"
                data-testid="contact-name-input"
                required
                maxLength={120}
                value={form.name}
                onChange={set("name")}
                placeholder="Dit navn"
                className={inputCls}
              />
            </div>
            <div>
              <label htmlFor="kontakt-email" className="text-xs font-medium tracking-[0.25em] text-[#B46A45]">
                E-MAIL
              </label>
              <input
                id="kontakt-email"
                data-testid="contact-email-input"
                type="email"
                required
                value={form.email}
                onChange={set("email")}
                placeholder="din@email.dk"
                className={inputCls}
              />
            </div>
            <div>
              <label htmlFor="kontakt-besked" className="text-xs font-medium tracking-[0.25em] text-[#B46A45]">
                BESKED
              </label>
              <textarea
                id="kontakt-besked"
                data-testid="contact-message-input"
                required
                rows={5}
                maxLength={4000}
                value={form.message}
                onChange={set("message")}
                placeholder="Hvad vil du gerne vide mere om?"
                className={`${inputCls} resize-none`}
              />
            </div>
            <div className="pt-4 text-center">
              <button
                type="submit"
                data-testid="contact-submit-button"
                disabled={sending}
                className="rounded-full bg-[#3F5A47] px-9 py-3.5 text-sm font-medium text-[#FAF7F1] transition-colors duration-300 hover:bg-[#2F3338] disabled:opacity-60"
              >
                {sending ? "Sender…" : "Send besked"}
              </button>
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
